import { FC, useState } from "react"

import { FieldError } from '../../../../../widgets'
import { ILookupProps } from './ILookupProps'
import { Typeahead } from 'react-bootstrap-typeahead'
import clsx from 'clsx'
import { useLookupData } from './useLookupData'
import { useLookupValidationSchema } from './LookupValidationSchema'

interface ILookupFieldProps extends ILookupProps {
    id: string
    className?: string
}

export const SimpleLookup: FC<ILookupFieldProps> = (props) => {
    const { id, value: initValue, className, disabled, tableLookup } = props
    const { lookupData, isLoading } = useLookupData(tableLookup)
    const schema = useLookupValidationSchema(props)
    const [error, setError] = useState<string>();
    const [value, setValue] = useState<string>(initValue || '');

    const handleOnChange = (selected: Record<string, any>) => {
        const record = selected ? selected[0] : undefined;
        const selectedValue = record ? record["id"] || '' : ''
        setValue(selectedValue)

        schema?.validate(selectedValue)
            .then(() => setError(undefined))
            .catch((error) => setError(error.message))
    }

    return (<>
        <Typeahead
            id={id}
            className={clsx(className, "custom-typeahead typeahead-sm")}
            labelKey={option => `${(option as any).label || ''}`}
            isLoading={isLoading}
            clearButton={true}
            disabled={disabled}
            options={lookupData}
            filterBy={['label']}
            onChange={handleOnChange}
            selected={(lookupData).filter(p => p.id === value) || ''}
        />

        {error && <FieldError show={true} message={error} />}
    </>
    )
}

